'use client'
import { Flex, Text } from '@mantine/core'
import { useParams } from 'next/navigation'
import { useTranslations } from 'next-intl'

import { getMarketBreadcrumbHref } from '@/app/[locale]/price/_components/HomepageV2/breadcrumbMarket'
import ChevronRight from '@/assets/icons/chevron-right.svg'
import { I18nLink } from '@/i18n/navigation'

export default function CategoriesHeader({
  category,
  categoriesHref = '/price/categories',
}: {
  category?: string
  categoriesHref?: string
}) {
  const t = useTranslations()
  const { locale } = useParams<{ locale: string }>()
  return (
    <Flex align={'center'} mb={32}>
      {/* WWW-5191: US region 下 All Coins 跳到首页 crypto tab，避免落到默认的 predictions */}
      <I18nLink href={getMarketBreadcrumbHref(locale, 'crypto')} prefetch={true}>
        <Text c={'var(--content-secondary)'} variant={'subtitle'}>
          {t('common.coinCategoryTypes.allCoins')}
        </Text>
      </I18nLink>
      <ChevronRight height={16} fill={'var(--content-tertiary)'} />
      <I18nLink href={categoriesHref} prefetch={true}>
        <Text variant={'subtitle'} c={'var(--content-primary)'}>
          {t('category.categories')}
        </Text>
      </I18nLink>
      {category && (
        <>
          <ChevronRight height={16} fill={'var(--content-tertiary)'} />
          <Text variant={'subtitle'} c={'var(--content-primary)'}>
            {category}
          </Text>
        </>
      )}
    </Flex>
  )
}
